<template>
    <v-text-field :label="title" :value="value" style="padding: 10px 0; font-size: 13px;" :outlined="!isIE" dense
        hide-details readonly>
    </v-text-field>
</template>

<script>
    export default {
        props: {
            title: {
                required: false,
                type: String
            },
            text: {
                required: false,
                type: String
            }
        },
        computed: {
            value() {
                return (this.text === "") ? "-" : this.text
            }
        },
        data() {
            return {
                isIE: (navigator.userAgent.indexOf("MSIE ") > -1) || (navigator.userAgent.indexOf("Trident/") > -1)
            }
        }
    }
</script>